import { OnInitError } from '@wix/checkout-components';
import { useCheckoutStore, CheckoutActions } from '../../../../providers';
import { NotificationOptions, SentryReporter } from '../../../../types';

interface DisplayInitErrorOptions {
  invokeNotification: (notificationProps: NotificationOptions) => void;
  reloadPage: () => void;
  buttonText: string;
  defaultMessage: string;
  message?: string;
}

export interface UseOnInitErrorOptions {
  notificationData: DisplayInitErrorOptions;
  removeUnloadListener: () => void;
  logError: SentryReporter;
}

function displayInitError({
  invokeNotification,
  message,
  defaultMessage,
  buttonText,
  reloadPage,
}: DisplayInitErrorOptions): void {
  invokeNotification({
    isDisplayed: true,
    message: message || defaultMessage,
    actionText: buttonText,
    onActionButtonClick: reloadPage,
  });
}

export function useOnInitError(
  options?: UseOnInitErrorOptions,
): OnInitError | undefined {
  const { dispatch } = useCheckoutStore();
  if (options) {
    return ((error, orderPageEventAggregator, errorInfo) => {
      const { removeUnloadListener, notificationData } = options;

      removeUnloadListener && removeUnloadListener();
      displayInitError({
        message: errorInfo?.translatedErrorMessage,
        ...notificationData,
      });
      if (orderPageEventAggregator) {
        dispatch(
          CheckoutActions.setOrderPageEventAggregator(orderPageEventAggregator),
        );
      }
      options.logError(error);
    }) as OnInitError;
  }

  return undefined;
}
